import Vue from 'vue';
import * as constDefine from '@/store/constDefine';
import router from '@/router'
import crypto from "../util/crypto"
import auth from "../util/auth"
import http from "../util/http"
import countryCode from "../json/country_code.json"
import {getCryptoUserInfo} from "@/util/cryptoLocalStorage";

Array.prototype.array_unique = function (key) {
    // 有輸入key值作為判定的依據則用二維陣列的方式處理，會對指定的key值做unique
    if (key !== undefined && key !== '' && typeof key === 'string') {
        let keyIndex = [];
        let newArr = [];
        this.forEach((ele)=>{
            if (keyIndex.indexOf(ele[key])<0) {
                newArr.push(ele);
                keyIndex.push(ele[key]);
            }
        })
        return newArr;
    }else{   /** 沒有輸入key值則以一維陣列的方式處理 */
        return this.filter((value, index, self)=>{
            return self.indexOf(value) === index;
        })
    }
  };
//   無限載入套件判定是否有連續重複載入同一比資料
Array.prototype.tmz_load_push = function () {
    const args = Array.prototype.slice.call(arguments);
    // 取得最後跟現在要載入的筆數相同數量的資料視為上一次載入的資料
    let refrenceArr = this.slice((this.length-args.length),(this.length));
    // 判斷上一次載入的資料跟當前要載入的資料是否完全相同
    if (JSON.stringify(refrenceArr) !== JSON.stringify(args)) {
        this.push(...args);
    }
    return this.length;
}
export default {
    showNotify: function (message, notifyType, duration=3000) {
        let notify = Vue.prototype.$message;
        let type;
        //關閉先前產生的提示視窗
        notify.closeAll();
        //判斷型態帶入不同狀態
        switch (typeof notifyType) {
            case "string": {
                type = notifyType;
                break
            }
            case "boolean": {
                if (notifyType === true) {
                    type = "success";
                    break
                } else {
                    type = "error";
                    break
                }
            }
            default: {
                type = 'error';
                break
            }
        }

        notify({
            type: type,
            message: message,
            duration: duration,
            showClose: true,
        });
    },
    getPreviewAryUrl(previewAry, index) {
        let url;
        let strIndex;

        if (process.env.VUE_APP_MODE === "release") {
            strIndex = previewAry[index].search("file.oinapp.com");
            url = previewAry[index].slice(strIndex + 16,);
        } else {
            strIndex = previewAry[index].search("file-test.oinapp.com");
            url = previewAry[index].slice(strIndex + 21,);
        }

        if (strIndex === -1) {
            return ""
        } else {
            return url
        }
    },
    padLeft(str, lenght) {
        if (str.length >= lenght)
            return str;
        else
            return this.padLeft("0" + str, lenght);
    },
    dateFormat(fmt, date = new Date()) {
        let o = {
            "M+": date.getMonth() + 1, //月份
            "d+": date.getDate(), //日
            "h+": date.getHours(), //小時
            "m+": date.getMinutes(), //分
            "s+": date.getSeconds(), //秒
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度
            "S": date.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear().toString()).substr(4 - RegExp.$1.length));
        if (/(t)/.test(fmt)) fmt = fmt.replace(RegExp.$1, () => {
            //取當日
            //不直接用上面的date是避免改值
            let endDate = new Date();
            //將月份移至下個月份
            endDate.setMonth(endDate.getMonth() + 1);
            //設定為下個月份的第一天
            endDate.setDate(1);
            //將日期-1為當月的最後一天
            endDate.setDate(endDate.getDate() - 1);

            return endDate.getDate();
        });
        for (let k in o)
            if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, this.padLeft(o[k].toString(), RegExp.$1.length));
        return fmt;
    },
    numberFormat(n ,c, d, t){
        //小數點後有幾位 (超過的部分會四捨五入)
        c = isNaN(c = Math.abs(c)) ? 0 : c;
        //小數點的符號
        d = d === undefined ? "." : d;
        //千分位的符號
        t = t === undefined ? "," : t;
        let s = n < 0 ? "-" : "";
        let i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c)));
        let x = i.length
        let j = x > 3 ? x % 3 : 0;
        return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    },
    /** 判斷物件是否 非undefined也非null，都符合的話回傳true */
    notNull: function(obj) {
        return (obj !== undefined && obj !== null);
    },
    /** 判斷是否在 cordova環境中，是的話回傳true */
    isCordova: function() {
        return (window.cordova !== undefined && window.cordova !== null);
    },


    /** 分析 youtube影片 key，取得內嵌用影片 url  */
    getEmbedVideoUrl: function (url) {

        //https://youtu.be/k-1SMrfRqqQ?list=PLp8YAQVH95dxnA0-2MLxSW6k15blbVH64&t=24
        //https://youtu.be/-ct1eQLuHJ0?t=411

        let result = '', cutUrl = '';
        if ( this.notNull(url) && url !== '') {
            let videoKey = '';      //youtube 影片真正的 key字串
            let realVideoUrl = '';      //youtube 影片真正的網址
            let andSignSplit = [];      //以 &分隔出來的 url區段，要找出 watch?v= 或 youtu.be/ 後面的字串，才是真的 key

            //去掉 `?list=` 之後的網址
            cutUrl = url.substr(url.indexOf('?list=')+1);
            //去掉 `?t=` 之後的網址
            cutUrl = cutUrl.substr(cutUrl.indexOf('?t=')+1);
            //去掉 `&t=` 之後的網址
            cutUrl = cutUrl.substr(cutUrl.indexOf('&t=')+1);

            andSignSplit = cutUrl.split(`&`);
            //如果有 &字串
            if (andSignSplit.length > 0) {
                realVideoUrl = andSignSplit[0];
            } else {
                realVideoUrl = url;
            }

            //取得影片真正的 key
            if (realVideoUrl !== '') {
                let vSignSplit = [];
                if (realVideoUrl.indexOf(`watch?v=`) > -1) {
                    vSignSplit = realVideoUrl.split(`watch?v=`);

                } else if (realVideoUrl.indexOf(`youtu.be/`) > -1) {
                    vSignSplit = realVideoUrl.split(`youtu.be/`);
                }

                if (vSignSplit.length > 1) {
                    videoKey = vSignSplit[1];
                }
            }

            if (this.notNull(videoKey) && videoKey !== '') {
                //iOS App 從 file:// 載入不會帶 Referer，直接嵌入 YouTube 會出現 Error 153，改用 https 網域上的中繼頁（public/yt-embed.html）嵌入
                if (this.isCordova() && window.cordova.platformId === 'ios' && this.notNull(process.env.VUE_APP_YT_EMBED_URL)) {
                    result = `${process.env.VUE_APP_YT_EMBED_URL}?v=${encodeURIComponent(videoKey)}`;
                } else {
                    result = `https://www.youtube.com/embed/${videoKey}`;
                }
            }
            // console.log('videoKey = ' + videoKey);
        }

        return result;
    },

    /** iOS App 監聽頁面上的 iframe，將 YouTube 嵌入網址換成中繼頁，涵蓋所有 v-html 內嵌的影片（說明同 getEmbedVideoUrl） */
    watchYoutubeIframe: function () {
        if (!(this.isCordova() && window.cordova.platformId === 'ios' && this.notNull(process.env.VUE_APP_YT_EMBED_URL))
            || typeof MutationObserver === 'undefined') {
            return;
        }
        const embedReg = /^(?:https?:)?\/\/(?:www\.)?youtube(?:-nocookie)?\.com\/embed\/([\w-]{11})/;
        const replaceSrc = (frame) => {
            let match = (frame.getAttribute('src') || '').match(embedReg);
            if (match) {
                frame.setAttribute('src', `${process.env.VUE_APP_YT_EMBED_URL}?v=${match[1]}`);
            }
        };

        document.querySelectorAll('iframe').forEach(replaceSrc);
        new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes') {
                    if (mutation.target.tagName === 'IFRAME') {
                        replaceSrc(mutation.target);
                    }
                    return;
                }
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType !== 1) {
                        return;
                    }
                    if (node.tagName === 'IFRAME') {
                        replaceSrc(node);
                    } else {
                        node.querySelectorAll('iframe').forEach(replaceSrc);
                    }
                });
            });
        }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['src']});
    },

    /** 完整google地圖url分析，格式 https://www.google.com/map/place//@緯度,經度/data=商店資料 */
    analyzeGoogleMapUrl: function (url) {
        let googleMapLat = null;
        let googleMapLng = null;
        let googleMapStoreInfoData = null;

        if (this.notNull(url) && url !== '') {
            let signSplit = [];      //以 &分隔出來的 url區段，要找出 '/後面的字串，才是真的 key
            signSplit = url.split(`/`);

            //如果有 &字串
            if (signSplit.length > 0) {
                signSplit.forEach( (item, index) => {
                    if (item !== '' ) {
                        if(item.indexOf(`@`) > -1) {
                            //GPS
                            let commaSplit = [];
                            commaSplit = item.split(`,`);
                            let gpsData = this.analyzeGps(commaSplit);
                            if (this.notNull(gpsData)) {
                                googleMapLat = gpsData.lat;
                                googleMapLng = gpsData.lng;
                            }
                            // console.log('gpsData:' + gpsData);

                        } else if (item.indexOf(`data=`) > -1) {
                            //店家資訊
                            let commaSplit = [];
                            commaSplit = item.split(`?`);
                            googleMapStoreInfoData = this.analyzeStoreInfo(commaSplit);

                            // console.log('storeData:' + this.googleMapStoreInfoData);
                        }
                    }
                });
            }

            return {
                googleMapLat,
                googleMapLng,
                googleMapStoreInfoData,
            };

        } else {
            return null;
        }
    },

    /** 分析 GPS座標 */
    analyzeGps: function (stringSplit) {
        let result = null;

        if (this.notNull(stringSplit) && stringSplit.length > 1) {
            let lat = stringSplit[0].replace('@', '');  //緯度
            let lng = stringSplit[1];           //經度
            result = {lat, lng};
        }
        // console.log(`analyzeGps: ${result.lat}, ${result.lng}`);
        return result;
    },

    /** 分析商店資料 */
    analyzeStoreInfo: function (stringSplit) {
        let result = '';       //
        if (this.notNull(stringSplit) && stringSplit.length > 0) {
            result = stringSplit[0].replace('data=', '');
        }
        // console.log(`analyzeStoreInfo: ${data}`);
        return result;
    },

    /** 取得 browser */
    getBrowser: function(){
        let browser ;
        if (this.notNull(window.cordova)){
            if(this.notNull(window.cordova.InAppBrowser)){
                browser = window.cordova.InAppBrowser;
            } else {
                browser = window;
            }
        } else {
            browser = window;
        }
        return browser;
    },
    /** 以 browser 開啓網頁 */
    openUrl: function(url){
        let browser = this.isCordova()? window.cordova.InAppBrowser: window;
        // window.open(url, '_blank');
        browser.open(url, '_system');
    },
    /** 以經緯度開啓地圖 */
    // openMap: function(lat, lng){
    //     // window.open(`https://www.google.com/maps/@${lat},${lng},16z`, '_blank');
    //     window.cordova.InAppBrowser.open(`https://www.google.com/maps/@${lat},${lng},16z`, '_system');
    // },
    /** 以經緯度開啓地圖 */
    openMap: function(lat, lng, storeInfoData = null, storeName = ''){
        let browser = this.isCordova()? window.cordova.InAppBrowser: window;
        if (this.notNull(storeInfoData)) {
            browser.open(`https://www.google.com.tw/maps/place/${storeName}/@${lat},${lng},16z/data=${storeInfoData}`, '_system');
        } else {
            browser.open(`https://www.google.com/maps/@${lat},${lng},16z`, '_system');
        }
    },
    /** 以地址開啓地圖 */
    openMapByAddress: function(address){

        let browser = this.isCordova()? window.cordova.InAppBrowser: window;
        browser.open(`https://www.google.com/maps/place/${address},16z`, '_system');

    },
    /** 以經緯度開啓導航 */
    openGoogleNavigation: function(lat, lng){
        let browser = this.isCordova()? window.cordova.InAppBrowser: window;
        browser.open(`https://www.google.com/maps/dir//@${lat},${lng},16z`, '_system');
    },
    /** 以地址開啓導航 */
    openGoogleNavigationByAddress: function(address){
        let browser = this.isCordova()? window.cordova.InAppBrowser: window;
        browser.open(`https://www.google.com/maps/dir//${address},16z`, '_system');
    },

    /** 開啓網頁，並對網頁左上角 X按鈕功能進行監控與功能連動，點下網頁的 X會關閉整個瀏覽器 */
    openUrlWithCloseBtn: function(url){

        let self = this;
        let browser = this.isCordova()? window.cordova.InAppBrowser: window;

        //使用 _system的話會呼叫 app外部的 browser來開網頁
        let appInBrowser = browser.open(url, '_blank', 'toolbar=no,location=no' + http.browserOpenFeatures());

        // 注意，這一段是針對使用 InAppBrowser這個套件專用的方法
        //如果是 cordova開啓，就植入 javascript持續取得網頁網址 location.href，
        //直到轉成訂位成功的頁面，再將另一段 javascript植入加入行事曆按鈕中，發射 message給 app接收
        if (this.isCordova()) {
            if (this.notNull(appInBrowser)) {
                appInBrowser.addEventListener('message', function(...args) {
                    if (self.notNull(args) && self.notNull(args[0])) {
                        let msgObj = args[0];
                        if (msgObj.type === 'message') {
                            if (self.notNull(msgObj.data) &&
                                self.notNull(msgObj.data.message)){

                                if (msgObj.data.message.indexOf('close') >= 0) {
                                    appInBrowser.close();
                                }
                            }
                        }
                    }
                }, false);

                //監聽 '載入完成' 事件
                appInBrowser.addEventListener('loadstop', function(event) {
                    //取得訂位網頁左上角的'關閉'按鈕，並植入關閉的方式
                    appInBrowser.executeScript({
                        code: `
                                document.getElementById('closeBtn').addEventListener("click", function(e) {
                                    const message = { message: 'close' };
                                    webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(message));
                                }, false);
                            `
                    });
                }, true);
            }
        }
    },

    /** 執行手機的撥號功能 */
    callTel: function(tel){
        if (this.isCordova()) {
            window.cordova.InAppBrowser.open('tel:' + tel, '_system');
        } else {
            window.open('tel:' + tel, '_system');
        }
    },

    /** 儲存 gps定位 */
    getGpsLocation: function(successCallback, errorCallback) {
        let self = this;
        let innerSuccessCallback = function (position) {
            let lng = position.coords.longitude;
            let lat = position.coords.latitude;
            // console.log(`innerSuccessCallback: lng:${lng}, lat:${lat}`);
            self.saveGps(lng, lat);
            successCallback(position);
        };

        let innerErrorCallback = function (error) {
            let lng = self.getLastLng();
            let lat = self.getLastLat();
            if (!!lng === false) {
                lng = 0;
            }
            if (!!lat === false) {
                lat = 0;
            }

            self.saveGps(lng, lat);
            errorCallback(error);
        };

        if (this.isRegetGPS()) {
            //如果這次跟上次實際抓 GPS的間隔時間太長，就重新抓一次新的GPS
            navigator.geolocation.getCurrentPosition(innerSuccessCallback, innerErrorCallback, {
                enableHighAccuracy: true,
                timeout: 3000,
                maximumAge: 0,
            });
        } else {
            let pos = this.genPosObject(this.getLastLng(), this.getLastLat());

            //不用重新取GPS，結束
            successCallback(pos);
        }
    },

    /** 產生 pos物件 */
    genPosObject: function(lng, lat) {
        return {
            coords: {
                latitude: lat,
                longitude: lng,
                altitude: 0,
                accuracy: 0,
                heading: 0,
                velocity: 0,
                altitudeAccuracy: 0
            },
            timestamp: 0,
        };
    },

    /** 儲存 gps定位 */
    saveGps: function(lng, lat) {
        sessionStorage.setItem('lng', lng);
        sessionStorage.setItem('lat', lat);
        sessionStorage.setItem('gps_time', Date.now().toString());
    },

    /** 是否要重取GPS？ true:重取 */
    isRegetGPS: function() {
        let result = true;
        let lastTime = sessionStorage.getItem('gps_time');
        if (this.notNull(lastTime)) {
            let time = Number(lastTime);
            //超過一定秒數就回傳 true，重新取得GPS。距離上次取得的時間點超過5分鐘，就重新取一次GPS
            let nowTime = Date.now();
            result = ((nowTime - time)/1000) > 300;
            // console.log(`isRegetGPS: ${nowTime} - ${time} = ${nowTime-time} = ${result}`);

            // result = result || (this.getLastLng() === 0) && (this.getLastLat() === 0);
        }
        return result;
    },

    /** 取得上次的經度 */
    getLastLng: function() {
        let result = 0;
        let last = sessionStorage.getItem('lng');
        if (this.notNull(last)) {
            result = Number(last);
        }
        return result;
    },

    /** 取得上次的緯度 */
    getLastLat: function() {
        let result = 0;
        let last = sessionStorage.getItem('lat');
        if (this.notNull(last)) {
            result = Number(last);
        }
        return result;
    },
    /**清空購物車 */
    clearCart: function (vm) {
        if (vm.takeoutId !== 0) {
            if(this.isCordova()) {
                vm.$sqlite.delete('delete from order_record_meal_choiceList',[],function(resultSet){});
                vm.$sqlite.delete('delete from order_record_meal_data',[],function(resultSet){});
            } else {
                vm.$sqlite.deleteDB("order_record_meal_choiceList","","",function(resultSet){});
                vm.$sqlite.deleteDB("order_record_meal_data","","",function(resultSet){});
            }
        } else {
            vm.$store.commit('setCartStoreId', 0);
            if(this.isCordova()) {
                vm.$sqlite.delete('delete from shopping_cart_meal_choiceList',[],function(resultSet){});
                vm.$sqlite.delete('delete from shopping_cart_meal_data',[],function(resultSet){});
            } else {
                vm.$sqlite.deleteDB("shopping_cart_meal_choiceList","","",function(resultSet){});
                vm.$sqlite.deleteDB("shopping_cart_meal_data","","",function(resultSet){});
            }
        }
    },

    /** 新增行事曆的事件 (需安裝 cordova-plugin-calendar套件
     * 並在 index.html 加入 <script type="text/javascript" src="js/Calendar.js"/> ) */
    addCalendarEvent: function (platform, eventTitle, year, month, date, hours, minutes) {

        if (this.notNull(platform)) {
            let os = platform.toLowerCase();
            if (os === 'ios' || os === 'android') {
                if (this.notNull(window.plugins) && this.notNull(window.plugins.calendar)) {
                    // prep some variables
                    //new(year , month , date , hours , minutes , seconds , ms ): Date;
                    let startDate = new Date(year, month, date, hours, minutes, 0, 0); // beware: month 0 = january, 11 = december
                    let endDate = new Date(year, month, date, hours+2, minutes, 0, 0);
                    let title = eventTitle;
                    let eventLocation = ""; //"Home";
                    let notes = ""; //"Some notes about this event.";

                    let success = function (message) {
                        // alert("Success: " + JSON.stringify(message));
                        alert("已將訂位行程加入行事曆");
                    };
                    let error = function (message) {
                        // alert("Error: " + message);
                        alert("無法將訂位行程加入行事曆");
                    };

                    // 建立新行事曆種類
                    // if you want to create a calendar with a specific color, pass in a JS object like this:
                    // let createCalOptions = window.plugins.calendar.getCreateCalendarOptions();
                    // createCalOptions.calendarName = "My Cal Name";
                    // createCalOptions.calendarColor = "#FF0000"; // an optional hex color (with the # char), default is null, so the OS picks a color
                    // window.plugins.calendar.createCalendar(createCalOptions, success, error);

                    // create a calendar (iOS only for now)
                    // window.plugins.calendar.createCalendar(calendarName,success,error);

                    // 新增行事曆事件
                    window.plugins.calendar.createEventInteractively(title, eventLocation, notes, startDate, endDate,
                        success, error);
                }
            }
        }
    },

    /** 過濾掉不該有的字
     * 除了中、日、韓、英數字和底線以外，全部濾掉
     *  */
    getClearStrRegExp: function (str) {
        // 漢字的範圍 \u4e00-\u9fa5
        // 韓文的範圍 \x3130-\x318f
        // 韓文的範圍 \xac00-\xd7a3 (不用)
        // 日文的範圍 \u0800-\u4e00
        const rules = /[^\u4e00-\u9fa5\x3130-\x318f\u0800-\u4e00\w]+/g;
        return str.replace(rules, "");
    },

    /** 新增 Google Analytics 4 (Firebase Analytics)追蹤事件 - 目前打開的畫面名稱
     * (需安裝 cordova-plugin-firebasex 套件，並在 Firebase的 Analytics後台的 "即時" 裡面才能看到統計
     *  */
    addGAEventViewName: function (viewName) {
        if ( window.FirebasePlugin ) {
            let FirebasePlugin = window.FirebasePlugin;
            FirebasePlugin.setScreenName(viewName);
            // FirebasePlugin.logEvent("main_page_event_2", {param1: "64"});
        // } else {
        //     console.log(`### non FirebasePlugin ... `);
        }
    },

    /** 新增 Google Analytics 4 (Firebase Analytics)追蹤事件 - 要記錄的事件名稱，可傳入附加的自定義參數
     * (需安裝 cordova-plugin-firebasex 套件，並在 Firebase的 Analytics後台的 "即時" 裡面才能看到統計
     * @param: paramJsonObj: 以Json物件定義的自定義參數，例: { param1: "64"}，可以爲 null
     *  # {string} eventName - name of event to log to Firebase Analytics. Limit of 40 characters.
     *      Dots are not allowed in eventName.
     *  # {object} eventProperties - key/value object of custom event properties.
     *      This must be a flat (non-nested) object.
     *      The value must be a primitive type such as string/number/etc. (not a complex object such as array or nested object).
     *      Limit of 40 characters for parameter name and 100 characters for parameter value.
     *  */
    addGAEventLog: function (logName, paramJsonObj) {
        if ( window.FirebasePlugin ) {
            let FirebasePlugin = window.FirebasePlugin;
            FirebasePlugin.logEvent(logName, paramJsonObj);
        // } else {
        //     console.log(`### non FirebasePlugin ... `);
        }
    },

    /** 滑動後取消鍵盤監聽 */
    blur(){
        let focusedElement = document.activeElement;
        focusedElement.blur();
    },

    /** 點擊推播進 app後的跳頁 */
    clickNotificationRouter: function (notificationData, nowRouterName) {
        let self = this
        let routerName = nowRouterName;

        let admin_token = window.localStorage.getItem('admin_token');
        let isLogin = (admin_token !== null && admin_token !== undefined && admin_token !== '');

        if (!this.notNull(notificationData)) {
            return;
        }

        // console.log(`clickNotificationRouter, nowRouterName= ${nowRouterName}, json: ${JSON.stringify(notificationData)}, isLogin=${isLogin}`);
        let notify = JSON.parse(notificationData);

        //不在app時,點擊背景推播訊息後進入
        switch (notify.action) {
            case constDefine.ACTION_FEEDBACK_LIST: {
                //意見反映
                if (isLogin) {
                    if (this.notNull(notify.messageListId) && notify.messageListId > 0) {
                        router.push({name: 'Chatroom', query:{'messageListId': notify.messageListId}});
                    } else {
                        router.push({name: 'Feedback'});
                    }
                }
                break;
            }
            case constDefine.ACTION_FINISH_ORDER: {
                //跳到消費明細
                let orderSn = notify.orderSn;
                if (isLogin) {
                    router.push({name: 'HistoryContent', params: {'orderSn': orderSn, 'openType': 'fmt'}});
                }
                break;
            }
            case constDefine.ACTION_SEND_COUPON: {
                if (isLogin) {
                    let couponId = notify.couponId;
                    if(routerName === 'Gift') {
                        let a = 1;
                    } else {
                        // router.push({name: 'Gift', params:{activeCategory: 'coupon', activeTab: 'use', couponId: couponId}});
                        // router.push({ name: 'LoyaltyCardPage', query:{id:item.id, 'activeCategory': activeCategory}});
                        router.push({name: 'CouponPage', query:{'id': 0, 'couponId': couponId, 'count': 0, 'activeCategory': 'coupon'}});
                    }
                }
                break;
            }
            case constDefine.ACTION_SEND_REWARD:
                break;
            case constDefine.ACTION_GIFT_COUPON: {
                //收到別人轉贈的券
                //跳到禮物盒-優惠卷
                if (isLogin) {
                    let couponListId = notify.couponListId;
                    if(routerName === 'Gift') {
                        let a = 1;
                    } else {
                        // router.push({name: 'Gift', params:{activeCategory: 'coupon', activeTab: 'use'}});
                        router.push({name: 'CouponPage', query:{'id': 0, 'couponId': couponListId, 'count': 0, 'activeCategory': 'coupon'}});
                    }
                }
                break;
            }
            case constDefine.ACTION_GO_OIN_CARD: {
                //跳到禮物盒-活動卡
                if (isLogin) {
                    let cardListId = notify.id;
                    if(routerName === 'Gift') {
                        let a = 1;
                    } else {
                        // router.push({name: 'Gift', params:{activeCategory: 'oinCard', activeTab: 'use'}});
                        // router.push({ name: 'LoyaltyCardPage', query:{id:couponId, 'activeCategory': 'oinCard'}});
                        //活動卡沒有獨立的詳細資訊頁，要先跳到禮物盒再進入卡片詳細資訊頁
                        router.push({ name: 'Gift', params:{ goToPageCardId:cardListId, activeCategory: 'oinCard', activeTab: 'use'}});
                    }
                }
                break;
            }
            case constDefine.ACTION_GO_REGISTER_GIFT: {
                //跳到禮物盒-活動卡
                if (isLogin) {
                    if(routerName === 'Gift') {
                        let a = 1;
                    } else {
                        router.push({name: 'Gift', params:{activeCategory: 'oinCard', activeTab: 'use'}});
                    }
                }
                break;
            }
            case constDefine.ACTION_GO_COUPON: {
                //跳到禮物盒-優惠卷
                if (isLogin) {
                    if(routerName === 'Gift') {
                        let a = 1;
                    } else {
                        if(notify.type === "couponExpirationNotice") {
                            router.push({name: 'Gift', params:{executeType: notify.type}});
                        } else {
                            router.push({name: 'Gift'});
                        }
                    }
                }
                break;
            }
            case constDefine.ACTION_ONLINE_ORDER: {
                //跳到點餐
                if (isLogin) {
                    let changePage = function() {
                        //notify.takeoutId
                        //notify.orderSn
                        if(routerName === 'OrderRecordDetail') {
                            let a = 1;
                        } else {
                            router.push({name: 'OrderRecordDetail',query:{orderSn: notify.orderSn}});
                        }
                    }

                    switch (notify.type) {
                        case 'AcceptOrder':
                        case 'RejectOrder':
                        case 'CompleteMeal':
                        case 'CompleteOrder':
                        case 'CancelOrder':
                            changePage();
                            break
                        default :
                            break;
                    }
                }
                break;
            }
            case constDefine.ACTION_GO_BOOKING_RECORD:
            case constDefine.ACTION_BOOKING_ADD:
            {
                let routerName = "BookRecord"
                let dataToken = crypto.objectToURIComponent({
                    usedType: routerName,
                    storeId: 'allStore',
                    goToPageBookingId: notify.bookingId,
                    goToPageBookingStoreId: notify.storeId,
                })

                router.push({name: routerName, query: {'dataToken': dataToken}})
                break;
            }
            case constDefine.ACTION_BOOKING_CANCEL:
                break;
            case constDefine.ACTION_AMOUNT_EXCHANGE_COUPON: {
                //金額兌換 (可能是集點數，要跳到點數卡？)
                if(routerName === 'Gift') {
                    let a = 1;
                } else {
                    let cardListId = notify.couponId;
                    router.push({name: 'Gift', params:{activeCategory: 'coupon', activeTab: 'use'}});
                    // router.push({name: 'CouponPage', query:{'id': '0', 'couponId': couponId, 'count': 0, 'activeCategory': 'coupon'}})
                    // router.push({ name: 'LoyaltyCardPage', query:{id:couponId, 'activeCategory': 'oinCard'}});
                }
                break;
            }
            case constDefine.ACTION_LOYALTY_CARD_EXCHANGE: {
                break;
            }
            case constDefine.ACTION_GO_LOYALTY_CARD: {
                //跳到禮物盒-集點卡
                if (isLogin) {
                    if(notify.id === 0) {
                        router.push({name: 'Gift', params:{activeCategory: 'loyaltyCard', activeTab: 'use'}});
                    } else {
                        let id = notify.id;
                        let type = notify.type;
                        router.push({ name: 'LoyaltyCardPage', query:{id: id, activeCategory: type}})
                    }
                }
                break;
            }
            case constDefine.ACTION_GO_ANNOUNCEMENT: {
                //跳到店家公告， storeId爲 0是享樂遊公告，要跳到個人中心公告頁
                let storeId = this.notNull(notify.storeId)? notify.storeId: 0;
                let itemId = this.notNull(notify.itemId)? notify.itemId: 0;
                router.push({name: 'Bulletin', query:{storeId: storeId, itemId: itemId}});
                break;
            }
            case constDefine.ACTION_GO_RESERVATION: {
                if(notify.type === "New") {
                    let dataToken = crypto.objectToURIComponent({
                        usedType:   "openReservationRecordDetailWeb",
                        id:         notify.reservationId,
                        userToken:  auth.getAdminToken(),
                        isCordova:  this.isCordova(),
                    });
                    let urlSet = process.env.VUE_APP_RESERVE_HOST + "/record/detail?dataToken=" +dataToken;
                    this.openUrlWithCloseBtn(urlSet);
                }
                break;
            }
            case constDefine.ACTION_GO_Reward_Point: {
                if(notify.id === 0 || notify.id === "0") {
                    router.push({name: 'Gift', params:{activeCategory: 'rewardPoint', activeTab: 'use'}});
                } else {
                    let dataToken = crypto.objectToURIComponent({
                        "usedType":  "BonusPointsPage",
                        "id":        notify.id,
                    })
                    router.push({name: 'BonusPointsPage', query: {dataToken: dataToken}})
                }
                break;
            }
            case constDefine.ACTION_GO_Gift_Pack_Detail: {
                if (isLogin) {
                    let id = notify.id;
                    if(routerName === 'Gift') {
                        let a = 1;
                    } else {
                        router.push({name: 'CouponPage', query:{'id': 0, 'couponId': id, 'count': 0, 'activeCategory': 'coupon', 'offersType': constDefine.TicketType.GiftPack.id}});
                    }
                }
                break;
            }
            case constDefine.ACTION_GO_COUPON_RECORD: {
                //跳到禮物盒-優惠卷
                if (isLogin) {
                    if(routerName === 'Gift') {
                        let a = 1;
                    } else {
                        router.push({name: 'Gift', params:{activeCategory: 'coupon', activeTab: 'record'}});
                    }
                }
                break;
            }
            default :
                break;
        }
    },

    /** 點擊跳頁連結進 app後的跳頁 */
    clickRedirectRouter: function (paramObj, actionCheck) {
        let result = false;
        let self = this

        let admin_token = window.localStorage.getItem('admin_token');
        let isLogin = (admin_token !== null && admin_token !== undefined && admin_token !== '');

        if (!this.notNull(paramObj)) {
            return result;
        }

        switch (actionCheck) {
            case constDefine.REDIRECT_ACTION_ORDER:
                {
                    if (self.notNull(paramObj.action) && self.notNull(paramObj.storeId)) {
                        if (paramObj.action === constDefine.REDIRECT_ACTION_ORDER) {
                            if (isLogin) {
                                result = true;
                            }
                        }
                    }
                }
                break;
            default :
                break;
        }
        return result;

    },

    /** 轉址 api後的第一階跳頁
     * @param: type,
     * @param: paramObj, 轉址 api傳來的參數(param)轉成的物件
     * */
    isRedirect: function (type, paramObj) {
        let self = this

        if (self.notNull(paramObj)) {
            //判斷參數類型然後跳頁
            if (type === constDefine.REDIRECT_TYPE_REDIRECT && self.notNull(paramObj)) {
                if (self.notNull(paramObj.action) && self.notNull(paramObj.storeId)) {
                    if (paramObj.action === constDefine.REDIRECT_ACTION_ORDER) {
                        return true;
                    }
                }
            }
        }
        return false;
    },

    /** 轉址 api後的第一階跳頁
     * @param: type,
     * @param: paramObj, 轉址 api傳來的參數(param)轉成的物件
     * */
    clickRedirectStep1: function (type, paramObj) {
        let self = this

        if (self.notNull(paramObj)) {
            //判斷參數類型然後跳頁
            if (type === constDefine.REDIRECT_TYPE_REDIRECT && self.notNull(paramObj)) {
                if (self.notNull(paramObj.action) && self.notNull(paramObj.storeId)) {
                    if (paramObj.action === constDefine.REDIRECT_ACTION_ORDER) {
                        router.push({name: 'StoreInfo', query: {"id": paramObj.storeId}});
                    }
                }
            }
        }
        return false;
    },

    /** 轉址 api後的第二階跳頁
     * @param: paramObj, 轉址 api傳來的參數(param)轉成的物件
     * */
    clickRedirectStep2: function (paramObj) {
        let self = this

        if (!self.notNull(paramObj)) {
            return;
        }

        //判斷參數類型然後跳頁
        if (paramObj.action === constDefine.REDIRECT_ACTION_ORDER) {
            router.push({name: 'StoreInfo', query: {"id": paramObj.storeId}});
        }
    },

    /** 儲存導向參數
     *  params：轉址 api傳來的參數(param)轉成的物件
     *  */
    saveAppRedirectParam: function(params) {
        //寫入暫存，返回後再由呼叫者自行從 sessionStorage 中取得結果
        //AppRedirectParams 內容爲物件， {action:order, storeId:291}(範例)
        sessionStorage.setItem('AppRedirectParams', JSON.stringify(params));
    },
    clrAppRedirectParam: function() {
        //掃描結果寫入暫存，返回後再由呼叫者自行從 sessionStorage 中取得結果
        this.saveAppRedirectParam('');
    },
    /** 讀取導向參數(讀完記得清掉)
     * 回傳 params轉成的物件
     * */
    getAppRedirectParam: function() {
        //從 sessionStorage 中取得參數
        let params = sessionStorage.getItem('AppRedirectParams');
        if (this.notNull(params) && params !== '') {
            return JSON.parse(params);
        }
        return null;
    },

    checkPhone(phone, countryCodeData = null){
        if (countryCodeData !== null ) {
            if (countryCodeData.code === "+886") {
                let regexp = /^09[0-9]{8,}$/;
                return regexp.test(phone)
            } else if (phone.length > 3 && (phone.length + (countryCodeData.code.length - 1)) < 21) {
                const isPhone = new RegExp(`^[0-9]{${phone.length}}$`);
                return isPhone.test(phone);
            } else {
                return false;
            }
        } else {
            return false;
        }
    },

    reg(type, value, custom) {
        switch (type){
            case 'addressComplete': {
                const rule = new RegExp("(\\D+?[縣市])(\\D+?(市區|鎮區|鎮市|[鄉鎮市區]))(\\D+?[村里])?([0-9]+[鄰])?(\\D+?(村路|[路街道段]))(\\D?段)?([0-9]+巷)?([0-9]+弄)?([0-9]+號?)(-[0-9]+?(號))?([0-9]+樓)?(.+)?");
                return rule.test(value);
            }
            case 'address': {
                const rule = new RegExp("(\\D+?[村里])?([0-9]+[鄰])?(\\D+?(村路|[路街道段]))(\\D?段)?([0-9]+巷)?([0-9]+弄)?([0-9]+號?)(-[0-9]+?(號))?([0-9]+樓)?(.+)?");
                return rule.test(value);
            }
            case 'url': {
                const rule = new RegExp('^(https|http)://[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]');
                return rule.test(value);
            }
            case 'email': {
                const rule = new RegExp("^\\w+((-\\w+)|(.\\w+))*@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+)*.[A-Za-z]+$");
                return rule.test(value);
            }
            case 'tel': {
                const rule = new RegExp('^[0-9]{2}-[0-9]{7,8}$');
                return rule.test(value);
            }
            case 'phone': {
                const rule = new RegExp('^(09|9)[0-9]{8}$');
                return rule.test(value);
            }
            case 'taxIdNumber': {
                const rule = new RegExp('^[0-9]{8}$');
                return rule.test(value);
            }
            case 'mobileBarcode': {
                const rule = new RegExp('^/[0-9A-Z+-.]{7}$');
                return rule.test(value);
            }
            case 'custom': {
                const rule = new RegExp(custom);
                return rule.test(value);
            }
            default: {
                return false;
            }
        }
    },
    setSortFilter(event, curSortField, sortField, sortType, sortClickCount, type) {
        const el=event.target.parentNode.getElementsByClassName('filter')
        for(let i = 0; i < el.length; i++) {
            el[i].classList.remove('active-Re','active')
        }
        if (curSortField === sortField) {//判斷是否為同一欄位點擊，是的話則改變排序類型
            if (sortClickCount >= 1) {//同個欄位點擊2次以上,則回覆到一開始的排序
                sortField = ""
                sortType = ""
                el[type].classList.remove('active-Re','active')
            } else if (sortType === "asc") {
                sortType = "desc"
                el[type].classList.add('active')
            } else if (sortType === "desc") {
                sortType = "asc"
                el[type].classList.add('active-Re')
            }
            sortClickCount++;//點擊同個欄位時,紀錄點擊到第幾次
        } else {
            sortType = "desc"
            el[type].classList.add('active')
            sortClickCount = 0//切換欄位時,點擊次數歸0
        }

        return {
            sortField:          sortField,
            sortType:           sortType,
            sortClickCount:     sortClickCount,
        }
    },

    dataTokenObject(url) {
        let returnData = {
            status: false,
            dataObject: {},
        }

        let checkStr = "?dataToken="
        if(url.indexOf("http") !== -1 && url.indexOf(checkStr) !== -1) {
            returnData.status = true
            returnData.dataObject = crypto.uriComponentToObject(url.substr(url.indexOf(checkStr)).replace(checkStr, ""))
        }

        return returnData
    },

    /** 儲存登入後要轉的下一個頁面 */
    setPathAfterLogin: function (pathAfterLogin, param) {
        sessionStorage.setItem('pathAfterLogin', pathAfterLogin);
        sessionStorage.setItem('pathParam', JSON.stringify(param));
    },

    /** 取得登入後跳頁路徑 */
    getPathAfterLogin: function () {
        return sessionStorage.getItem('pathAfterLogin');
    },

    /** 取得登入後跳頁參數 */
    getParamAfterLogin: function () {
        let param = sessionStorage.getItem('pathParam');
        if (this.notNull(param) && param !== "") {
            return JSON.parse(param);
        } else {
            return null;
        }
    },

    /** 清空登入後跳頁路徑和參數 */
    clearCartPathSession: function () {
        sessionStorage.setItem('pathAfterLogin', "");
        sessionStorage.setItem('pathParam', "");
    },

    /** 取得單筆國碼資訊 */
    getCountryData: function (code, countryName) {
        const result = countryCode.filter(item => item.countryEnName === countryName && item.countryCode === code);
        if (result.length > 0) {
            let country = {
                enName: result[0].countryEnName,
                cnName: result[0].countryCnName,
                code: result[0].countryCode,
            }
            return country;
        } else {
            return 0;
        }
    },

    /** 保留物件中指定的屬性並回傳新物件
     * @keepPropAry: 字串陣列，要保留的屬性名稱
     * */
    getObjectWithProp: function (srcObject, keepPropAry) {
        if (this.notNull(srcObject) && (typeof srcObject === "object")) {
            if (this.notNull(keepPropAry) && keepPropAry.length > 0) {
                let newObj = Object.keys(srcObject).reduce((acc, key) => {
                    if (keepPropAry.includes(key)) {
                        acc[key] = srcObject[key];
                    }
                    return acc;
                }, {});
                return newObj;
            }
        }
        return null;
    },

    /** 移除物件中指定的屬性並回傳新物件
     * @removePropAry: 字串陣列，要移除的屬性名稱
     * */
    getObjectRemoveProp: function (srcObject, removePropAry) {
        if (this.notNull(srcObject) && (typeof srcObject === "object")) {
            if (this.notNull(removePropAry) && removePropAry.length > 0) {
                let newObj = Object.keys(srcObject).reduce((acc, key) => {
                    if (!removePropAry.includes(key)) {
                        acc[key] = srcObject[key];
                    }
                    return acc;
                }, {});
                return newObj;
            }
        }
        return null;
    },

    isMobile() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const isMobileDevice = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
        const isSmallScreen = window.innerWidth <= 768;
        //ipad瀏覽器要判斷進去才用這，目前ipad瀏覽器是走網頁流程
        //const isNewiPad = (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); // iPadOS 13+

        return isMobileDevice || isSmallScreen;
    },

    getUserData() {
        let userData = getCryptoUserInfo();
        let genderName = ""

        switch (userData.gender) {
            case 1:
                genderName = "先生"
                break;
            case 2:
                genderName = "小姐"
                break;
        }

        return {
            phone: userData.phone,
            nickname: userData.nickName,
            avatar: userData.picture,
            genderName: genderName,
            userToken: auth.getAdminToken(),//只能用當前登入的，因為在使用時會驗證是否被登出或失效之類的
            timestamp: new Date().getTime(),
            countryCode: userData.countryCode,
            countryName: userData.countryName,
        }
    },
}
